.ColourKey {
  margin-top: 10px;
  margin-bottom: 10px;

  & > div {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 20px;

    & > div {
      display: flex;
      align-items: center;
      gap: 8px;

      & > span:first-child {
        width: 14px;
        height: 14px;
        border-radius: 3px;
        display: inline-block;
        border: 1px solid rgba(0, 0, 0, 0.15);
      }
    }
  }
}

.Clickable > div > div {
  cursor: pointer;
}

.Inactive {
  opacity: 0.5;
  text-decoration: line-through;
}
